import 'select2/dist/js/select2.full.js'

jQuery('.activity__select select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.tfg-content-members__select select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.pfts select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown select').select2({
    width: '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown-mobile select').select2({
    width: '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

function initGravityFormSelect2() {
    jQuery('.gform_wrapper select').not('.gform-datepicker-calendar select').each(function () {
        const $select = jQuery(this)

        if ($select.hasClass('select2-hidden-accessible') || $select.closest('.gform-datepicker-calendar').length) {
            return
        }

        $select.select2({
            width: '100%'
        })
    })
}

initGravityFormSelect2()

jQuery(document).on('gform_post_render', function () {
    initGravityFormSelect2()
})

// Blackbaud injects donation selects after load and hides extra spans.
// Native selects are styled in `_donate.scss` so Select2 is not applied here.



jQuery('.general__dropdown select').not('[data-vue-select]').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.header__language select').each(function () {
    const $select = jQuery(this)
    const $parent = $select.closest('.header__language')

    $select.select2({
        width: 'auto',
        minimumResultsForSearch: Infinity,
        dropdownCssClass: 'header__language-dropdown',
        dropdownParent: $parent
    }).on('change', function () {
        window.location = jQuery(this).val()
    })
})
// jQuery(document).ready(function() {
//     jQuery('#select_province').select2({
//         width: '100%'
//     })
// })
